export default {
    intro: `Lieber Fahrgast,<br><br>
auf dieser Seite können Sie das Guthaben Ihrer Prepaid-Bezahlkarte der Mainzer Mobilität abfragen sowie aufladen.<br><br>
Geben Sie hierzu einfach die Kartennummer Ihrer Prepaid-Bezahlkarte nachfolgend ein. Diese finden Sie auf der Kartenrückseite unten links.<br><br>Hinweis: Sie müssen nur noch die letzten 5 Ziffern Ihrer Kartennummer ergänzen.
    `,
    accordions: [
        {
            title: "Nutzungsbedingungen der Guthabenkarte",
            content: `
            <p></p>
            `,
        },
        {
            title: "Nutzungshinweise am Terminal",
            content: `
            <p></p>
            `,
        },
        {
            title: "Umgang mit der alten Guthabenkarte auf GiroGo-Basis",
            content: `
            <p></p>
            `,
        },
    ],
    errors: {
        enterNumber: "Kartennummer eingeben",
        tooShort: "Kartennummer ist zu kurz",
        tooLong: "Kartennummer ist zu lang",
        unknownError: "Es ist ein Fehler aufgetreten. Bitte nochmals versuchen",
        notAllowed: "You are not allowed to perform this operation",
        wrongNumber: "Ungültige Kartennummer",
        wrongAmountFormat: "Ungültiges Betragsformat",
        emptyBalance: "Ihre Karte enthält kein Guthaben",
        balanceError:
            "Guthaben konnte nicht abgefragt werden, bitte erneut versuchen",
    },
};
